import { css } from '@emotion/react';

const makeLoaderStyling = ({ animationType, height, theme }) => {
  const { desktopSmall, tabletSmall, mobileSmall } = theme.breakpoints.values;

  return {
    wrapper: css({
      height,
      display: 'flex',
      alignItems: 'flex-end',
    }),
    container: css({
      height: '100%',
      display: 'block',
      overflowY: 'visible',
    }),
    message: css({
      fontWeight: theme.mvf.typography.weight.thick,
      ...{
        [theme.breakpoints.up('desktopMedium')]: {
          fontSize: theme.mvf.fontSize.huge,
        },
        [theme.breakpoints.between('desktopSmall', 900)]: {
          fontSize: theme.mvf.fontSize.big,
        },
        [theme.breakpoints.between('tablet', 708)]: {
          fontSize: theme.mvf.fontSize.large,
        },
        [theme.breakpoints.between('tabletSmall', 680)]: {
          fontSize: theme.mvf.fontSize.swoll,
        },
        [theme.breakpoints.between('mobileMedium', 500)]: {
          fontSize: theme.mvf.fontSize.hefty,
        },
        [theme.breakpoints.between('mobileSmall', 310)]: {
          fontSize: theme.mvf.fontSize.medium,
        },
      },
      marginRight: theme.mvf.spacing.large,
      marginLeft: theme.mvf.spacing.large,
      ...(animationType === 'standard' && {
        marginTop: theme.mvf.spacing.large,
      }),
      textAlign: 'center',
    }),
    lottieLoader: css({
      marginTop: 0,
      '& lottie-player': {
        ...(animationType === 'standard' && {
          [theme.breakpoints.up(desktopSmall)]: {
            height: 225,
          },
          [theme.breakpoints.between(tabletSmall, 708)]: {
            height: 175,
          },
          [theme.breakpoints.between(mobileSmall, 500)]: {
            height: 155,
          },
        }),
        ...(animationType !== 'standard' && {
          [theme.breakpoints.up(desktopSmall)]: {
            height: 250,
          },
          [theme.breakpoints.between(tabletSmall, 708)]: {
            height: 200,
          },
          [theme.breakpoints.between(mobileSmall, 500)]: {
            height: 180,
          },
        }),
      },
    }),
    fallbackLoader: css({
      marginTop: theme.mvf.spacing.large,
      textAlign: 'center',
    }),
  };
};

export default makeLoaderStyling;
